import { workspaceManager as workspace } from "../../constants/actionTypes";

const getWorkspaceManagerList = (data) => ({
  type: workspace.GET_WORKSPACE_DASHBOARD_LIST,
  data: data,
});

const setWorkspaceManagerList = (data) => ({
  type: workspace.SET_WORKSPACE_DASHBOARD_LIST,
  data: data,
});

const requestWorkspaceDetails = (data) => ({
  type: workspace.REQUEST_WORKSPACE_DETAILS,
  data: data,
});

const setWorkspaceDetails = (data) => ({
  type: workspace.SUCCESS_WORKSPACE_DETAILS,
  data: data,
});

const errorWorkspaceDetails = (data) => ({
  type: workspace.ERROR_WORKSPACE_DETAILS,
  data: data,
});

const requestWorkspaceDetailsUsers = (id, urlParams) => ({
  type: workspace.REQUEST_WORKSPACE_DETAILS_USERS,
  id: id,
  urlParams: urlParams,
});

const successWorkspaceDetailsUsers = (data) => ({
  type: workspace.SUCCESS_WORKSPACE_DETAILS_USERS,
  data: data,
});

const resetWorkspaceDetailsUsers = () => ({
  type: workspace.RESET_WORKSPACE_DETAILS_USERS,
});

const errorWorkspaceDetailsUsers = (data) => ({
  type: workspace.ERROR_WORKSPACE_DETAILS_USERS,
  data: data,
});

const requestDeleteWorkspaceUser = (data) => ({
  type: workspace.REQUEST_DELETE_WORKSPACE_USER,
  data: data,
});

const successDeleteWorkspaceUser = (data) => ({
  type: workspace.SUCCESS_DELETE_WORKSPACE_USER,
  data: data,
});

const errorDeleteWorkspaceUser = (data) => ({
  type: workspace.ERROR_DELETE_WORKSPACE_USER,
  data: data,
});

const setWorkspaceManagerListError = (data) => ({
  type: workspace.SET_WORKSPACE_DASHBOARD_LIST_ERROR,
  payload: data,
});

const setGetWorkspaceListLoading = (data) => ({
  type: workspace.SET_WORKSPACE_LIST_LOADING,
  payload: data,
});
const worksSpaceCreateAuthConfig = (data) => ({
  type: workspace.CREATE_AUTH_CONFIG,
  payload: data,
});
const worksSpaceEditAuthConfig = (data) => ({
  type: workspace.EDIT_AUTH_CONFIG,
  payload: data,
});
const worksSpaceCreateAddResource = (data) => ({
  type: workspace.ADD_RESOURCE,
  payload: data,
});
const worksSpaceEditAddResource = (data) => ({
  type: workspace.EDIT_RESOURCE,
  payload: data,
});
const worksSpaceCreate = (data) => ({
  type: workspace.CREATE_WORKSPACE,
  payload: data,
});
const worksSpaceEdit = (data) => ({
  type: workspace.EDIT_WORKSPACE,
  payload: data,
});

const workSpaceCreateSuccess = (data) => ({
  type: workspace.CREATE_WORKSPACE_SUCCESS,
  payload: data,
});

const workSpaceEditSuccess = (data) => ({
  type: workspace.EDIT_WORKSPACE_SUCCESS,
  payload: data,
});

const workSpaceCreateError = (data) => ({
  type: workspace.CREATE_WORKSPACE_ERROR,
  payload: data,
});

const worksSpaceAddResourceSuccess = (data) => ({
  type: workspace.ADD_RESOURCE_SUCCESS,
  payload: data,
});

const worksSpaceAddResourceError = (data) => ({
  type: workspace.ADD_RESOURCE_ERROR,
  payload: data,
});

const createAuthConfigSuccess = (data) => ({
  type: workspace.CREATE_AUTH_CONFIG_SUCCESS,
  payload: data,
});

const createAuthConfigError = (data) => ({
  type: workspace.CREATE_AUTH_CONFIG_ERROR,
  payload: data,
});

const saveWorkspaceLoading = (data) => ({
  type: workspace.BUTTON_LOADING,
  payload: data,
});

const getResourceTemplate = (data) => ({
  type: workspace.GET_RESOURCE_TEMPLATE,
  payload: data,
});

const setResourceTemplate = (data) => ({
  type: workspace.SET_RESOURCE_TEMPLATE,
  payload: data,
});
const deleteWorkspaceRequest = (data) => ({
  type: workspace.DELETE_WORKSPACE_REQUEST,
  payload: data,
});

const setDeleteWorkspaceSuccess = (data) => ({
  type: workspace.DELETE_WORKSPACE_SUCCESS,
  payload: data,
});

const setPostApiSuccessful = (data) => ({
  type: workspace.POST_API_SUCCESSSFUL,
  payload: data,
});

const setActiveWorkspace = (data) => ({
  type: workspace.SET_ACTIVE_WORKSPACE,
  payload: data,
});

const setWorkspaceLoading = (data) => ({
  type: workspace.SET_WORKSPACE_LOADING,
  payload: data,
});
const setResourceLoading = (data) => ({
  type: workspace.SET_RESOURCE_LOADING,
  payload: data,
});
const setAuthLoading = (data) => ({
  type: workspace.SET_AUTH_LOADING,
  payload: data,
});
const getWorkspacebyId = (data) => ({
  type: workspace.GET_WORKSPACE_BY_ID,
  payload: data,
});
const getWorkspaceResourcebyId = (data) => ({
  type: workspace.GET_WORKSPACE_RESOURCE_BY_ID,
  payload: data,
});
const getWorkspaceAuthConfigbyId = (data) => ({
  type: workspace.GET_WORKSPACE_AUTH_CONFIG_BY_ID,
  payload: data,
});

const setWorkspaceResource = (data) => ({
  type: workspace.SET_WORKSPACE_RESOURCE,
  payload: data,
});
const setWorkspaceAuthConfig = (data) => ({
  type: workspace.SET_WORKSPACE_AUTH_CONFIG,
  payload: data,
});
const setWorkspaceAuthConfigError = (data) => ({
  type: workspace.SET_WORKSPACE_AUTH_CONFIG_ERROR,
  payload: data,
});
const setInstanceSizeAndPricingProfile = (data) => ({
  type: workspace.SET_INSTANCE_SIZE_PRICING,
  payload: data,
});
const getInstanceSizeAndPricingProfile = (data) => ({
  type: workspace.GET_INSTANCE_SIZE_PRICING,
  payload: data,
});
const instanceSizeAndPricingProfileLoading = (data) => ({
  type: workspace.INSTANCE_SIZE_PRICING_LOADING,
  payload: data,
});
const resetWorkSpaceForm = () => ({
  type: workspace.RESET_WORKSPACE_FORM,
});
const setResTemplateLoading = (data) => ({
  type: workspace.SET_RES_TEMPLATE_LOADING,
  payload: data,
});
const workspaceActionRequest = (id, data) => ({
  type: workspace.WORKSPACE_ACTION_REQUEST,
  payload: { id, data },
});
const setWorkspaceActionSuccess = (data) => ({
  type: workspace.WORKSPACE_ACTION_SUCCESS,
  payload: data,
});

const getWorkspaceResourceList = (data) => ({
  type: workspace.GET_WORKSPACE_RESOURCE_LIST,
  data: data,
});

const setWorkspaceResourceList = (data) => ({
  type: workspace.SET_WORKSPACE_RESOURCE_LIST,
  data: data,
});

const setWorkspaceResourceListError = (data) => ({
  type: workspace.SET_WORKSPACE_RESOURCE_LIST_ERROR,
  payload: data,
});

const getPublicWorkspaceResourceList = (data) => ({
  type: workspace.GET_PUBLIC_WORKSPACE_RESOURCE_LIST,
  data: data,
});

const setPublicWorkspaceResourceList = (data) => ({
  type: workspace.SET_PUBLIC_WORKSPACE_RESOURCE_LIST,
  data: data,
});

const setPublicWorkspaceResourceListError = (data) => ({
  type: workspace.SET_PUBLIC_WORKSPACE_RESOURCE_LIST_ERROR,
  payload: data,
});

const setPublicWorkspaceListLoading = (data) => ({
  type: workspace.SET_PUBLIC_WORKSPACE_LIST_LOADING,
  payload: data,
});

const linkDeLinkResource = (data) => ({
  type: workspace.LINK_DELINK_RESOURCE,
  payload: data,
});

const listUserInvitation = (data) => ({
  type: workspace.LIST_USER_INVITATION,
  payload: data,
});

const setUserInvitation = (data) => ({
  type: workspace.SET_USER_INVITATION,
  payload: data,
});

const setUserInvitationLoading = (data) => ({
  type: workspace.SET_USER_INVITATION_LOADING,
  payload: data,
});
const generateInviteLink = (data) => ({
  type: workspace.GENERATE_INVITE_LINK,
  payload: data,
});
const generateInviteLoading = (data) => ({
  type: workspace.GENERATE_INVITE_LOADING,
  payload: data,
});
const setInviteLink = (data) => ({
  type: workspace.SET_INVITE_LINK,
  payload: data,
});

const setLinkDelinkLoading = (data) => ({
  type: workspace.SET_LINK_DELINK_LOADING,
  payload: data,
});

const setLinkDeLinkSuccess = (data) => ({
  type: workspace.SET_LINK_DELINK_SUCCESS,
  payload: data,
});
const requestDownloadInvitation = (data) => ({
  type: workspace.REQUEST_DOWNLOAD_INVITATION,
  data: data,
});

const successDownloadInvitation = (data) => ({
  type: workspace.SUCCESS_DOWNLOAD_INVITATION,
  data: data,
});

const errorDownloadInvitation = (data) => ({
  type: workspace.ERROR_DOWNLOAD_INVITATION,
  data: data,
});

const clearDownloadInvitation = () => ({
  type: workspace.CLEAR_DOWNLOAD_INVITATION,
});

const requestResendInvitation = (data) => ({
  type: workspace.REQUEST_RESEND_INVITATION,
  data: data,
});

const successResendInvitation = (data) => ({
  type: workspace.SUCCESS_RESEND_INVITATION,
  data: data,
});

const errorResendInvitation = (data) => ({
  type: workspace.ERROR_RESEND_INVITATION,
  data: data,
});

const requestTenantListForUsage = (data) => ({
  type: workspace.REQUEST_TENANT_LIST_USAGE,
  data: data,
});

const successTenantListForUsage = (data) => ({
  type: workspace.SUCCESS_TENANT_LIST_USAGE,
  data: data,
});

const errorTenantListForUsage = (data) => ({
  type: workspace.ERROR_TENANT_LIST_USAGE,
  data: data,
});

const requestWorkspaces = (data, params = {}) => ({
  type: workspace.REQUEST_WORKSPACES,
  data: data,
  params: params
});

const successWorkspaces = (data) => ({
  type: workspace.SUCCESS_WORKSPACES,
  data: data,
});

const errorWorkspaces = (data) => ({
  type: workspace.ERROR_WORKSPACES,
  data: data,
});

const requestGenerateReportList = (data) => ({
  type: workspace?.REQUEST_GENERATE_REPORT_LIST,
  data: data,
});

const successGenerateReportList = (data) => ({
  type: workspace?.SUCCESS_GENERATE_REPORT_LIST,
  data: data,
});

const errorGenerateReportList = (data) => ({
  type: workspace?.ERROR_GENERATE_REPORT_LIST,
  data: data,
});

const requestGenerateReport = (data) => ({
  type: workspace?.REQUEST_GENERATE_REPORT,
  data: data,
});

const resetGenerateReport = () => ({
  type: workspace?.RESET_GENERATE_REPORT,
});

const successGenerateReport = (data) => ({
  type: workspace?.SUCCESS_GENERATE_REPORT,
  data: data,
});

const errorGenerateReport = (data) => ({
  type: workspace?.ERROR_GENERATE_REPORT,
  data: data,
});

const setWebSocketWorkspaceResourceList = (data) => ({
  type: workspace.SET_WEBSOCKET_WORKSPACE_RESOURCE_LIST,
  data: data,
});

const getInvitation = (data) => ({
  type: workspace?.GET_INVITATION,
  data: data,
});

const setInviteSuccess = (data) => ({
  type: workspace?.SET_INVITATION,
  data: data,
});

const setInviteError = (data) => ({
  type: workspace?.SET_INVITATION_ERROR,
  data: data,
});

const getWorkspaceVerified = (data) => ({
  type: workspace?.GET_WORKSPACE_VERIFIED,
  data: data,
});

const setWorkspaceVerified = (data) => ({
  type: workspace?.SET_WORKSPACE_VERIFIED,
  data: data,
});

const getWorkspaceExtPacks = (data) => ({
  type: workspace?.GET_WORKSPACE_EXT_PACKS,
  data: data,
});

const setWorkspaceVerifiedError = (data) => ({
  type: workspace?.SET_WORKSPACE_VERIFIED_ERROR,
  data: data,
});

const setInviteLinkAvailable = (data) => ({
  type: workspace.SET_INVITE_LINK_AVAILABLE,
  data: data,
});

const localUserLoginAction = (data) => ({
  type: workspace.LOCAL_USER_LOGIN,
  data: data,
});

const LoginForAAD = (data) => ({
  type: workspace.AAD_USER_LOGIN,
  data: data,
});

const LoginForAADSuccess = (data) => ({
  type: workspace.AAD_USER_LOGIN_SUCCESS,
  data: data,
});

const LoginForAADError = (data) => ({
  type: workspace.AAD_USER_LOGIN_ERROR,
  data: data,
});

const getWSAuthResponse = (data) => ({
  type: workspace.GET_WS_AUTH_RES,
  data: data,
});

const workSpaceAuthSuccess = (data) => ({
  type: workspace.WS_AUTH_RES_SUCCESS,
  data: data,
});

const workSpaceAuthError = (data) => ({
  type: workspace.WS_AUTH_RES_ERROR,
  data: data,
});

const tenantListForWorkspace = (data) => ({
  type: workspace.TENANT_LIST_FOR_WORKSPACE,
  data: data,
});

const setTenantListForWorkspace = (data) => ({
  type: workspace.SET_TENANT_LIST_FOR_WORKSPACE,
  data: data,
});

const requestWorkspaceAddUser = (data) => ({
  type: workspace.REQUEST_WORKSPACE_ADD_USER,
  payload: data,
});

const successWorkspaceAddUser = (data) => ({
  type: workspace.SUCCESS_WORKSPACE_ADD_USER,
  payload: data,
});

const errorWorkspaceAddUser = (data) => ({
  type: workspace.ERROR_WORKSPACE_ADD_USER,
  payload: data,
});

const requestWorkspaceEditUser = (id, data) => ({
  type: workspace.REQUEST_WORKSPACE_EDIT_USER,
  id: id,
  payload: data,
});

const successWorkspaceEditUser = (data) => ({
  type: workspace.SUCCESS_WORKSPACE_EDIT_USER,
  payload: data,
});

const errorWorkspaceEditUser = (data) => ({
  type: workspace.ERROR_WORKSPACE_EDIT_USER,
  payload: data,
});

const clearWorkspaceAddUser = () => ({
  type: workspace.CLEAR_WORKSPACE_ADD_USER,
});

// Add Workspace Resources
const addWorkspaceResourcesAction = (data) => ({
  type: workspace.ADD_WORKSPACE_RESOURCES_ACTION,
  payload: data,
});
const addWorkspaceResourcesSuccess = (data) => ({
  type: workspace.ADD_WORKSPACE_RESOURCES_SUCCESS,
  payload: data,
});
const addWorkspaceResourcesError = (data) => ({
  type: workspace.ADD_WORKSPACE_RESOURCES_ERROR,
  payload: data,
});
const addWorkspaceResourcesReset = () => ({
  type: workspace.ADD_WORKSPACE_RESOURCES_RESET,
});
const addWorkspaceResourcesLoading = (data) => ({
  type: workspace.ADD_WORKSPACE_RESOURCES_LOADING,
  payload: data,
});

const getAllCloudVMSkuLoading = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_SKU_LOADING,
  payload: payload
})
const getAllCloudVMSkuAction = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_SKU_ACTION,
  payload: payload
})
const getAllCloudVMSkuSuccess = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_SKU_SUCCESS,
  payload: payload
})
const getAllCloudVMSkuError = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_SKU_ERROR,
  payload: payload
})
const getAllCloudVMSkuReset = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_SKU_RESET,
  payload: payload
})

const getAllCloudVMInstanceLoading = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_INSTANCE_LOADING,
  payload: payload
})
const getAllCloudVMInstanceAction = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_INSTANCE_ACTION,
  payload: payload
})
const getAllCloudVMInstanceSuccess = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_INSTANCE_SUCCESS,
  payload: payload
})
const getAllCloudVMInstanceError = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_INSTANCE_ERROR,
  payload: payload
})
const getAllCloudVMInstanceReset = (payload) => ({
  type: workspace.GET_ALL_CLOUD_VM_INSTANCE_RESET,
  payload: payload
})

export {
  getWorkspaceManagerList,
  setWorkspaceManagerList,
  setGetWorkspaceListLoading,
  setWorkspaceManagerListError,
  worksSpaceCreateAuthConfig,
  worksSpaceEditAuthConfig,
  worksSpaceCreateAddResource,
  worksSpaceEditAddResource,
  worksSpaceCreate,
  worksSpaceEdit,
  workSpaceCreateError,
  workSpaceCreateSuccess,
  worksSpaceAddResourceError,
  worksSpaceAddResourceSuccess,
  createAuthConfigError,
  createAuthConfigSuccess,
  saveWorkspaceLoading,
  getResourceTemplate,
  setResourceTemplate,
  requestWorkspaceDetails,
  setWorkspaceDetails,
  errorWorkspaceDetails,
  requestWorkspaceDetailsUsers,
  successWorkspaceDetailsUsers,
  resetWorkspaceDetailsUsers,
  errorWorkspaceDetailsUsers,
  deleteWorkspaceRequest,
  setDeleteWorkspaceSuccess,
  setPostApiSuccessful,
  setActiveWorkspace,
  setWorkspaceLoading,
  getWorkspacebyId,
  setInstanceSizeAndPricingProfile,
  getInstanceSizeAndPricingProfile,
  instanceSizeAndPricingProfileLoading,
  resetWorkSpaceForm,
  setWorkspaceResource,
  getWorkspaceResourcebyId,
  getWorkspaceAuthConfigbyId,
  setWorkspaceAuthConfig,
  setResourceLoading,
  setAuthLoading,
  setResTemplateLoading,
  workspaceActionRequest,
  setWorkspaceActionSuccess,
  getWorkspaceResourceList,
  setWorkspaceResourceList,
  setWorkspaceResourceListError,
  getPublicWorkspaceResourceList,
  setPublicWorkspaceResourceList,
  setPublicWorkspaceResourceListError,
  setPublicWorkspaceListLoading,
  linkDeLinkResource,
  listUserInvitation,
  setUserInvitation,
  setUserInvitationLoading,
  setLinkDelinkLoading,
  setLinkDeLinkSuccess,
  requestDeleteWorkspaceUser,
  successDeleteWorkspaceUser,
  errorDeleteWorkspaceUser,
  requestDownloadInvitation,
  successDownloadInvitation,
  errorDownloadInvitation,
  generateInviteLoading,
  setInviteLink,
  generateInviteLink,
  workSpaceEditSuccess,
  clearDownloadInvitation,
  requestResendInvitation,
  successResendInvitation,
  errorResendInvitation,
  requestTenantListForUsage,
  successTenantListForUsage,
  errorTenantListForUsage,
  requestWorkspaces,
  successWorkspaces,
  errorWorkspaces,
  requestGenerateReportList,
  successGenerateReportList,
  errorGenerateReportList,
  requestGenerateReport,
  successGenerateReport,
  errorGenerateReport,
  setWorkspaceAuthConfigError,
  getWorkspaceVerified,
  setWorkspaceVerified,
  setWorkspaceVerifiedError,
  setInviteLinkAvailable,
  setWebSocketWorkspaceResourceList,
  setInviteError,
  setInviteSuccess,
  getInvitation,
  localUserLoginAction,
  getWorkspaceExtPacks,
  LoginForAAD,
  LoginForAADSuccess,
  LoginForAADError,
  getWSAuthResponse,
  workSpaceAuthSuccess,
  workSpaceAuthError,
  tenantListForWorkspace,
  setTenantListForWorkspace,
  requestWorkspaceAddUser,
  successWorkspaceAddUser,
  errorWorkspaceAddUser,
  requestWorkspaceEditUser,
  successWorkspaceEditUser,
  errorWorkspaceEditUser,
  clearWorkspaceAddUser,
  resetGenerateReport,
  addWorkspaceResourcesAction,
  addWorkspaceResourcesSuccess,
  addWorkspaceResourcesError,
  addWorkspaceResourcesReset,
  addWorkspaceResourcesLoading,
  getAllCloudVMSkuLoading,
  getAllCloudVMSkuAction,
  getAllCloudVMSkuSuccess,
  getAllCloudVMSkuError,
  getAllCloudVMSkuReset,
  getAllCloudVMInstanceLoading,
  getAllCloudVMInstanceAction,
  getAllCloudVMInstanceSuccess,
  getAllCloudVMInstanceError,
  getAllCloudVMInstanceReset
};
